import { useSelector } from 'react-redux';
import '../css/app.css'
import '../css/main.css'
import '../css/common.css'
import '../css/payment.css'
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { LogOut, KeyRound } from 'lucide-react';

function Header() {
    let location = useLocation();
    let navigate = useNavigate();

    let HeaderTitle = useSelector((state) => { return state.HeaderTitle })
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);

    const [hamBtn, setHamBnt] = useState(false)
    const [logoutBtn, setLogoutBtn] = useState(false)
    const [message, setMessage] = useState("")
    const [passwordModal, setPasswordModal] = useState(false)

    const onSubmit = async () => {
        if (window.confirm("로그아웃을 하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/user/logout", {
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setLogoutBtn(false)
                    setHamBnt(false)
                    navigate('/')
                }
                else {
                    setMessage({ msg: "로그아웃에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    const ResponsiveImage = ({ smallSrc, largeSrc, alt, breakpoint = 768 }) => {
        const [windowWidth, setWindowWidth] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => setWindowWidth(window.innerWidth);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        const imageSrc = windowWidth < breakpoint ? smallSrc : largeSrc;

        return <img src={imageSrc} alt={alt} className="w-32" />;
    };

    const PasswordModalClose = () => {
        setPasswordModal(false)
        setHamBnt(false)
        setLogoutBtn(false)
    }

    return (
        <div style={{ display: location.pathname == '/' ? "none" : "" }}>
            <MessageModal message={message} />
            {passwordModal ? <ChangePassword setModal={PasswordModalClose} setMessage={setMessage} /> : ""}
            <div className={`mobile-menu md:hidden`}>
                <div className="mobile-menu-bar">
                    <Link to={`/paylist`} className="main_logo flex mr-auto gnb-link">
                        {
                            hostLogoImg == "onu"
                                ?
                                <ResponsiveImage
                                    smallSrc="/img/ong.jpg"
                                    largeSrc="/img/ong.jpg"
                                    alt="East Commerce Logo"
                                    breakpoint={768}
                                />
                                :
                                <ResponsiveImage
                                    smallSrc="/img/dl_logo_white.png"
                                    largeSrc="/img/dl_logo_white.png"
                                    alt="East Commerce Logo"
                                    breakpoint={768}
                                />
                        }
                    </Link>
                    {/* <a href="/" className="menu on" data-id="notice">공지</a> */}
                    <a href="/sugi" className="menu" data-id="payment">수기</a>
                    <a href="/paylist" className="menu" data-id="paylist">내역</a>
                    <a href="/settlement" className="menu" data-id="paylist">정산</a>
                    <div className="mobile-menu-wrap">
                        <a href="javascript:;" className={`mobile-menu-toggler  ${hamBtn ? "mobile-menu--active" : ""}`} onClick={() => setHamBnt(e => !e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="bar-chart-2" data-lucide="bar-chart-2" className="lucide lucide-bar-chart-2 w-8 h-8 text-white transform -rotate-90"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
                        </a>
                        {
                            hamBtn
                                ?
                                <div className={`dropdown-user-info w-56  ${hamBtn ? "show" : ""}`}>
                                    <ul className="dropdown-content bg-primary/80 before:block before:absolute before:bg-black before:inset-0 before:rounded-md before:z-[-1] text-white">
                                        <li className="p-2">
                                            <div className="font-medium">{JSON.parse(localStorage.getItem("userId"))?.co_nm ?? ""} 님</div>
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider border-white/[0.08]" />
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider border-white/[0.08]" />
                                        </li>
                                        <li>
                                            <Link id="logout-user" className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => setPasswordModal(e => !e)}>
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>비밀번호변경</div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link id="logout-user" className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => onSubmit()}>
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="toggle-right" data-lucide="toggle-right" className="lucide lucide-toggle-right w-4 h-4 mr-2"><rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>
                                                </svg> */}
                                                <LogOut style={{ width: "15px", marginRight: "8px" }} />
                                                <div>로그아웃</div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
            <div className="top-bar-boxed h-[70px] md:h-[65px] z-[51] border-b border-white/[0.08] mt-12 md:mt-0 -mx-3 sm:-mx-8 md:-mx-0 px-3 md:border-b-0 relative md:fixed md:inset-x-0 md:top-0 md:px-8 md:bg-gradient-to-b md:from-slate-100 md:to-transparent dark:md:from-darkmode-700" style={{ maxWidth: "1920px", margin: "0 auto" }}>
                <div className="h-full flex items-center -intro-x h-[45px]" style={{ float: "left" }}>
                    <a href="" className="logo -intro-x hidden md:flex  xl:w-[180px] xl:mr-0 mr-5 block" style={{ left: "20px" }}>
                        <img alt="ant" className="logo__image w-32" src="/img/dl_logo_white.png" />
                    </a>
                    <nav aria-label="breadcrumb" className="-intro-x h-[45px] mr-auto">
                        <ol className="breadcrumb breadcrumb-light">
                            <li className="breadcrumb-item pg_title" id="pg_title" value="">{HeaderTitle?.mainTitle ?? ""}</li>
                        </ol>
                    </nav>
                </div>
                <div className="" style={{ float: "right" }}>
                    <div className="h-full flex items-center intro-x h-[45px] mr-5" style={{ float: "left" }}>
                        <span style={{ color: "white" }}>{JSON.parse(localStorage.getItem("userId"))?.co_nm ?? ""} 님</span>
                    </div>
                    <div className="intro-x dropdown w-8 h-[45px] flex items-center dropdown_user" style={{ float: "left" }}>
                        <div className="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in scale-110" role="button" aria-expanded="false" data-tw-toggle="dropdown">
                            <img id="user-info-toggle" alt="Midone - HTML Admin Template" src="/img/profile-6.jpg" onClick={() => setLogoutBtn(e => !e)} />
                        </div>
                        {
                            logoutBtn
                                ?
                                <div className="dropdown-user-info w-56">
                                    <ul className="dropdown-content bg-primary/80 before:block before:absolute before:bg-black before:inset-0 before:rounded-md before:z-[-1] text-white">
                                        <li className="p-2">
                                            <div className="font-medium">{JSON.parse(localStorage.getItem("userId"))?.co_nm ?? ""}</div>
                                            <div className="text-xs text-white/60 mt-0.5 dark:text-slate-500">가맹점</div>
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider border-white/[0.08]" />
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider border-white/[0.08]" />
                                        </li>
                                        <li>
                                            <Link id="logout-user" className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => setPasswordModal(e => !e)}>
                                                <KeyRound style={{ width: "15px", marginRight: "8px" }} />
                                                <div>비밀번호변경</div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link id="logout-user" className="dropdown-item hover:bg-white/5" data-kind="pc" onClick={() => onSubmit()}>
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="toggle-right" data-lucide="toggle-right" className="lucide lucide-toggle-right w-4 h-4 mr-2"><rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>
                                                </svg> */}
                                                <LogOut style={{ width: "15px", marginRight: "8px" }} />
                                                <div>로그아웃</div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function ChangePassword({ setModal, setMessage }) {
    const [formData, setFormData] = useState({
        ID: JSON.parse(localStorage.getItem("userId"))?.mid ?? "",
        currentPw: '',
        newPw: '',
        newPwConfirm: '',
    });

    // input onChange 핸들러 (필드명(name)에 따라 업데이트)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/user/change-password", {
            currentPassword: formData.currentPw,
            newPassword: formData.newPw,
            confirmPassword: formData.newPwConfirm,
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                setMessage({ msg: "비밀번호변경 성공" })
                setModal()
            }
            else {
                setMessage({ msg: "비밀번호변경 실패" })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    return (
        <div id="admin-modal" className="modal show_modal" tabIndex="-1">
            <input type="hidden" id="event_check" value="update" />
            <div className="modal-dialog">
                <div className="modal-content marginTop30 admin-modal-sty">
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                padding: "0px",
                                borderBottom: "1px solid #E5E5E5",
                                backgroundColor: "#fff",
                            }}
                        >
                            <button
                                className="tab-btn active"
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "17px",
                                    fontWeight: "600",
                                    color: "#222",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom: "3px solid #3182F6",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer",
                                }}
                            >
                                비밀번호 변경
                            </button>
                    </div>

                    {/* form 태그 */}
                    <form
                        id="modal-form"
                        className="modal-body grid grid-cols-12 gap-4 gap-y-3"
                        onSubmit={(e) => e.preventDefault()}
                        style={{padding:"15px 0"}}
                    >
                        <div className="col-span-12">
                            <label className="form-label">ID</label>
                            <input
                                id="ID"
                                name="ID"
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={formData.ID}
                                disabled
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="currentPw" className="form-label">
                                현재 비밀번호
                            </label>
                            <input
                                id="currentPw"
                                name="currentPw"
                                type="password"
                                className="form-control"
                                placeholder=""
                                value={formData.currentPw}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPw" className="form-label">
                                새 비밀번호
                            </label>
                            <input
                                id="newPw"
                                name="newPw"
                                type="password"
                                className="form-control"
                                placeholder=""
                                value={formData.newPw}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="newPwConfirm" className="form-label">
                                새 비밀번호 확인
                            </label>
                            <input
                                id="newPwConfirm"
                                name="newPwConfirm"
                                type="password"
                                autoComplete="off"
                                className="form-control"
                                placeholder=""
                                value={formData.newPwConfirm}
                                onChange={handleChange}
                            />
                        </div>
                    </form>

                    <div className="modal-footer">
                        <button
                            id="signup-btn"
                            type="submit"
                            className="btn btn-primary"
                            onClick={onSubmit}
                        >
                            등록
                        </button>
                        <button
                            type="button"
                            data-tw-dismiss="modal"
                            className="btn btn-outline-secondary mr-1 admin-modal-btn"
                            onClick={() => setModal()}
                        >
                            닫기
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;